import { h } from "preact";

import ItemStack from "../../ItemStack";
import ComponentCard, { ComponentCardProps } from "../ComponentCard";

import styles from "./ComponentCardMirror.module.css";

interface Props extends ComponentCardProps {
    numberOfItems: number;
}

const COMPONENT_CARD_MIRROR_OPACITY = 0.75;

function ComponentCardMirrorContent({ ...componentCardProps }: Omit<Props, "numberOfItems">) {
    return (
        <div class={styles.componentCardMirror}>
            <ComponentCard {...componentCardProps}/>
        </div>
    );
}

function ComponentCardMirror({
    numberOfItems,
    ...componentCardProps
}: Props) {
    return (
        <ItemStack numberOfItems={numberOfItems} opacity={COMPONENT_CARD_MIRROR_OPACITY}>
            <ComponentCardMirrorContent {...componentCardProps}/>
        </ItemStack>
    );
}

export default ComponentCardMirror;
export { ComponentCardMirrorContent };
